import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconNote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M15 1H1v14h14zM4 7V5h8v2zm0 4V9h8v2z" clipRule="evenodd" />
  </svg>
);
export default SvgIconNote;
